import React from 'react';
import '../Style/DisplayProperty.css';
import ArrowTooltips from '../../ToolTip';
import utilService from '../../../services/utilService';

const PropertyIcon = ({icon, property, className = '', mainClassName = 'display-box-properties-name', maxLenString = 100}) => (
    <div className={`${mainClassName} ${className}`}>
        {property && 'name' in property && <>
            <img alt='label icon' src={icon} className='display-box-properties-img'/>
            <ArrowTooltips title={maxLenString < property.name.length ? <p>{property.name}</p> : ''} placement='top' >
                <p>
                    {`${utilService.normalizedSting(property.name, maxLenString)}`}
                </p>
            </ArrowTooltips>
        </>}
    </div>
);

export default PropertyIcon;
